
(function(){
  function initRoot(root){
    const header=root.querySelector('[data-ry-header]');
    if(header && header.classList.contains('ry-site-header--home')){
      const onScroll=()=>header.classList.toggle('is-scrolled',window.scrollY>40);
      onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
    }
    const btn=root.querySelector('[data-ry-nav-toggle]');
    const nav=root.querySelector('[data-ry-mobile-nav]');
    if(btn && nav){
      const close=()=>{nav.classList.remove('is-open');btn.setAttribute('aria-expanded','false');document.body.style.overflow='';};
      btn.addEventListener('click',()=>{const open=!nav.classList.contains('is-open');nav.classList.toggle('is-open',open);btn.setAttribute('aria-expanded',open?'true':'false');document.body.style.overflow=open?'hidden':'';});
      nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
      window.addEventListener('keydown',e=>{if(e.key==='Escape') close();});
    }
    root.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',function(e){
      const id=this.getAttribute('href'); if(!id || id==='#') return; const target=root.querySelector(id) || document.querySelector(id); if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
    }));
  }
  function boot(){document.querySelectorAll('.ry-redesign-root').forEach(initRoot)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
